import { configureStore } from "@reduxjs/toolkit";
import { slice } from "./slice";

export const { actions, reducer } = slice;

export const store = configureStore({ reducer });

export type RootState = ReturnType<typeof reducer>;
